import { Operator } from '@/modules/corporate/modules/database/fields/types';
import {
  getEmptyFieldValue,
  getFilterFieldValue,
} from '@/modules/corporate/modules/database/fields/utils/operators';
import { FilterOperatorEnum } from '@/types/schema';

const SelectOperators: Operator[] = [
  {
    labelKey: 'Database:Operators.Is',
    value: FilterOperatorEnum.Is,
    getFieldValue: getFilterFieldValue,
  },
  {
    labelKey: 'Database:Operators.IsNot',
    value: FilterOperatorEnum.IsNot,
    getFieldValue: getEmptyFieldValue,
  },
];

export default SelectOperators;
